import * as React from "react";
import { connect } from "react-redux";
import { mapDispatchToProps } from "../../redux/actions";
import "../../css/ProjectModal.scss";
import { ProjectStatusFilterBy } from "../../interfaces/interfaces";
import { GetFreightStatesCheckPostalCode } from "../../api-calls/projectDataService";
import AccordionHeader from "../Shared/AccordionHeader";
import { basisOfDesignOptions, normalizeBasisOfDesign } from "../../utilities/basisOfDesignOptions";

// expected props
interface IProps {
  updateRedux: any;
  reduxModals: any;
  reduxProjectManagement: any;
  reduxAuth: any;
}
// local state
interface IState {
  projectName: string;
  consultingEngineer: string;
  contractor: string;
  city: string;
  state: string;
  purchaseOrderNumber: string;
  salesOrderNumber: string;
  jobPhase: string;
  projectType: string;
  constructionType:string;
  designBasis: string;
  freightStates:any[];
  openAccordionSubmittal: boolean;
  openAccordionOrderRelease: boolean;
}

class ProjectModal extends React.Component<IProps, IState> {
  public state: IState = {
    projectName: "",
    consultingEngineer: "",
    contractor: "",
    city: "",
    state: "",
    purchaseOrderNumber: "",
    salesOrderNumber: "",
    jobPhase: ProjectStatusFilterBy[ProjectStatusFilterBy.Design],
    projectType: "",
    constructionType: "",
    designBasis: "",
    freightStates: [],
    openAccordionSubmittal: false,
    openAccordionOrderRelease: false
  };
  //This is a specific modal for adding or editing a project.  Input is project name.
  async componentDidMount() {
    if (this.props.reduxModals.modalId === "edit-project" || this.props.reduxModals.modalId === "add-new-project") {
      if (this.props.reduxModals.modalId === "edit-project"){
        this.setState({
          projectName: this.props.reduxProjectManagement.selectedProject?.projectName,
          consultingEngineer: this.props.reduxProjectManagement.selectedProject?.consultingEngineer,
          contractor: this.props.reduxProjectManagement.selectedProject?.contractor,
          city: this.props.reduxProjectManagement.selectedProject?.city,
          state: this.props.reduxProjectManagement.selectedProject?.state,
          jobPhase: this.props.reduxProjectManagement.selectedProject?.jobPhase ?? this.state.jobPhase,
          projectType: this.props.reduxProjectManagement.selectedProject?.projectType ?? this.state.projectType,
          constructionType: this.props.reduxProjectManagement.selectedProject?.constructionType ?? this.state.constructionType,
          designBasis: normalizeBasisOfDesign(this.props.reduxProjectManagement.selectedProject?.designBasis ?? this.state.designBasis),
          purchaseOrderNumber: this.props.reduxProjectManagement.selectedProject?.purchaseOrderNumber ?? this.state.purchaseOrderNumber,
          salesOrderNumber: this.props.reduxProjectManagement.selectedProject?.sapOrderNumber ?? this.state.salesOrderNumber
        });
      }
      //Get all the state choices for the dropdown and check to see if the zip code in the user's profile is in New York city.
      let postalCode = this.props.reduxAuth.postalCode ? this.props.reduxAuth.postalCode : "35242";
      let response = await GetFreightStatesCheckPostalCode(postalCode);

      //response.states is a list of objects that contain a state (state abbrev) and a fullState property.
      this.setState({freightStates: response.states});

      let setToNewYorkCity: boolean = false;

      //Set profileState to user's logged in profile state.
      let profileState = this.props.reduxAuth.state ? this.props.reduxAuth.state : "AL";

      if (profileState && profileState.toLowerCase() === "ny"){
        profileState = "NY - State";
      }
      //If the profile state is the full state name, find it's match and assign profile state to it's abbreviation.
      let fullStateExistsInDropdownList = response.states.find((stateInfo:any) => stateInfo.fullState.toLowerCase() === profileState?.toLowerCase());
      if (fullStateExistsInDropdownList){
        profileState = fullStateExistsInDropdownList.state;
      }
      //Verify the profile state exists in list of abbreviated states.
      let stateExistsInDropdownList = response.states.find((stateInfo:any) => stateInfo.state.toLowerCase() === profileState?.toLowerCase());

      //Set state to "NY - City" if:
      //1. The profile postal code is in NY - City.
      //2. There hasn't been a state selected by the user yet. 
      if (response.isNewYorkState === true && !this.props.reduxProjectManagement.selectedProject?.state){
        this.setState({state: "NY - City"});
        setToNewYorkCity = true;
      }

      //Set state to a value other than "NY - City" if:
      //1. The user's profile State matches one of the states in the dropdown.
      //2. There hasn't been a state selected by the user yet (state is empty or null and not "Choose an Options").
      //3. The profile postal code is not in NY - City.
      else if (stateExistsInDropdownList && setToNewYorkCity === false && 
        (!this.props.reduxProjectManagement.selectedProject?.state)){
        console.log("Set profile state.");
        this.setState({state: profileState});
      }
      //Default to Alabama if nothing has been previously selected and user's postal code is not in NY - City 
      //and user's state is not in the list of states.
      else if (!this.props.reduxProjectManagement.selectedProject?.state){
        console.log("Set default Alabama.");
        this.setState({state: "AL"});
      }
      else {
        console.log("Set state to previously selected.");
        this.setState({state: this.props.reduxProjectManagement.selectedProject?.state})
      }
    }
  }

  validateAndSave(fieldName: any, newValue: any) {
    if (newValue.length <= 50) {
      this.setState({ [fieldName]: newValue } as Pick<IState, keyof IState>);
    }
  }
  public render() {
    const title = this.props.reduxModals.modalId === "edit-project" ? "Edit Job" : "New Job";
    const buttonText = this.props.reduxModals.modalId === "edit-project" ? "Save" : "Create";

    return (
      <div className="newProject">
        <div className="header">{title}</div>
        <div className="InputRow">
          <label className="proj-modal-label">Job Name</label>
          <input
            className="projectInput"
            type="text"
            placeholder="Job Name"
            value={this.state.projectName}
            onChange={(event) => this.validateAndSave("projectName", event.currentTarget.value)}
            autoFocus
          />
        </div>
        <div className="InputRow">
          <div className="proj-modal-label">State</div>
          <div className="projectInputDropdown">
            <select className="proj-select" value={this.state.state} onChange={(event) => this.setState({ state: event.currentTarget.value })}>
              {this.getStateOptions()}
            </select>
          </div>
        </div>
        <div className="InputRow">
          <div className="proj-modal-label">Job Phase</div>
          <div className="projectInputDropdown">
            <select className="proj-select" value={this.state.jobPhase} onChange={(event) => this.setState({ jobPhase: event.currentTarget.value })}>
              <option>Design</option>
              <option>Bidding</option>
              <option>Submittal</option>
              <option>Release</option>
            </select>
          </div>
        </div>

        <div>
          <AccordionHeader
            title="Required for Submittal"
            subtitle=""
            classname="accordion-btn acc-btn-1000"
            active={this.state.openAccordionSubmittal}
            locked={false}
            hasError={false}
            togglePanel={() => this.togglePanelSubmittal()}
          />
          <div className={`acc-panel-1000 ${this.state.openAccordionSubmittal === true ? "acc-panel-active" : "acc-panel-inactive"}`}>
            <div className="accordion-content app-box-shadow"></div>

            <div className="InputRow">
              <label className="proj-modal-label">Consulting Engineer</label>
              <input
                className="projectInput"
                type="text"
                placeholder="Consulting Engineer"
                value={this.state.consultingEngineer ?? ""}
                onChange={(event) => this.validateAndSave("consultingEngineer", event.currentTarget.value)}
              />
            </div>
            <div className="InputRow">
              <label className="proj-modal-label">Contractor</label>
              <input
                className="projectInput"
                type="text"
                placeholder="Contractor"
                value={this.state.contractor ?? ""}
                onChange={(event) => this.validateAndSave("contractor", event.currentTarget.value)}
              />
            </div>
            <div className="InputRow">
              <label className="proj-modal-label">City</label>
              <input
                className="projectInput"
                type="text"
                placeholder="City"
                value={this.state.city ?? ""}
                onChange={(event) => this.validateAndSave("city", event.currentTarget.value)}
              />
            </div>
          </div>
        </div>


        <div>
          <AccordionHeader
            title="Required for Order Release"
            subtitle=""
            classname="accordion-btn acc-btn-1000"
            active={this.state.openAccordionOrderRelease}
            locked={false}
            hasError={false}
            togglePanel={() => this.togglePanelOrderRelease()}
          />
          <div className={`acc-panel-1000 ${this.state.openAccordionOrderRelease === true ? "acc-panel-active" : "acc-panel-inactive"}`}>
            <div className="accordion-content app-box-shadow"></div>

            <div className="InputRow">
              <div className="proj-modal-label">Project Type</div>
              <div className="projectInputDropdown">
                <select className="proj-select" value={this.state.projectType} onChange={(event) => this.setState({ projectType: event.currentTarget.value })}>
                  <option></option>
                  <option>Plan & Spec</option>
                  <option>Design Build/Assist</option>
                  <option>Other</option>
                </select>
              </div>
            </div>

            <div className="InputRow">
              <div className="proj-modal-label">Job Type</div>
              <div className="projectInputDropdown">
                <select className="proj-select" value={this.state.constructionType} onChange={(event) => this.setState({ constructionType: event.currentTarget.value })}>
                  <option></option>
                  <option>New Construction</option>
                  <option>Remodel</option>
                  <option>Replacement</option>
                </select>
              </div>
            </div>

            <div className="InputRow">
              <div className="proj-modal-label">Basis of Design</div>
              <div className="projectInputDropdown">
                <select className="proj-select" value={this.state.designBasis} onChange={(event) => this.setState({ designBasis: event.currentTarget.value })}>
                  {basisOfDesignOptions.map((option) => <option key={option} value={option}>{option}</option>)}
                </select>
              </div>
            </div>

            <div className="InputRow">
              <label className="proj-modal-label">Purchase Order #</label>
              <input
                className="projectInput"
                type="text"
                placeholder="Purchase Order #"
                value={this.state.purchaseOrderNumber}
                onChange={(event) => this.validateAndSave("purchaseOrderNumber", event.currentTarget.value)}
              />
            </div>
            <div className="InputRow">
              <label className="proj-modal-label">Sales Order #</label>
              <input
                className="projectInput"
                type="text"
                placeholder="Sales Order #"
                value={this.state.salesOrderNumber}
                onChange={(event) => this.validateAndSave("salesOrderNumber", event.currentTarget.value)}
              />
            </div>
          </div>
        </div>
        <div className="button-container">
          <div className="proj-create-btn" onClick={() => this.userResponse("ok")}>
            {buttonText}
          </div>
          <div className="proj-cancel-btn" onClick={() => this.userResponse("cancel")}>
            Cancel
          </div>
        </div>
      </div>
    );
  }
  private togglePanelSubmittal() {
    this.setState({ openAccordionSubmittal: !this.state.openAccordionSubmittal }); //toggle to opposite of current state
  }
  private togglePanelOrderRelease() {
    this.setState({ openAccordionOrderRelease: !this.state.openAccordionOrderRelease }); //toggle to opposite of current state
  }
  //This will trigger the componentDidUpdate method on ProjectManagement.tsx
  private userResponse(response: string) {
    
    if (response === "ok" && this.state.projectName !== "" && (this.props.reduxModals.modalId === "edit-project" || this.props.reduxModals.modalId === "add-new-project")) {
        let selectedProject = { ...this.props.reduxProjectManagement.selectedProject};
        selectedProject.projectName = this.state.projectName;
        selectedProject.consultingEngineer = this.state.consultingEngineer;
        selectedProject.contractor = this.state.contractor;
        selectedProject.city = this.state.city;
        selectedProject.state = this.state.state;
        selectedProject.jobPhase = this.state.jobPhase;
        selectedProject.constructionType = this.state.constructionType;
        selectedProject.projectType = this.state.projectType;
        selectedProject.designBasis = this.state.designBasis;
        selectedProject.purchaseOrderNumber = this.state.purchaseOrderNumber;
        selectedProject.sapOrderNumber = this.state.salesOrderNumber;
        this.props.updateRedux("UPDATE_PROJECT_MANAGEMENT", {selectedProject: selectedProject});
    }
    if (response === "cancel") {
      this.props.updateRedux("UPDATE_PROJECT_MANAGEMENT", { projectName: "" });
    }
    this.props.updateRedux("UPDATE_MODALS", { showModal: false, userResponse: response });
  }
  private getStateOptions(){
    const options = this.state.freightStates;
    
    if (options) {
      return options.map((item: any, index: number) => (
        <option key={index} value={item.state}>
          {item.state}
        </option>
      ));
    }
    return <option></option>;
  }
}

//------------------ Redux ----------------------------
function mapStateToProps(state: any) {
  return {
    reduxProjectManagement: state.reduxProjectManagement,
    reduxModals: state.reduxModals,
    reduxAuth: state.reduxAuth
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ProjectModal);
